import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import HotprintPopup from "./HotprintPopup";

export default function Hotprint() {
   const { loading, data } = useCollection("hotprint");
   const columns = [
      {
         title: "Adjustment Running Meters",
         dataIndex: "adjustmentRunningMeters",
         align: "center",
      },
      {
         title: "Adjustment Time",
         dataIndex: "adjustmentTime",
         align: "center",
      },
      {
         title: "Meters per Minute",
         dataIndex: "meterPerMinute",
         align: "center",
      },
      {
         title: "Print costs per Hour",
         dataIndex: "printCostsPerHour",
         align: "center",
      },
      {
         render: (value) => (
            <HotprintPopup
               adjustmentRunningMeters={value.adjustmentRunningMeters}
               adjustmentTime={value.adjustmentTime}
               meterPerMinute={value.meterPerMinute}
               printCostsPerHour={value.printCostsPerHour}
               id={value.id}
            />
         ),
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
